<template>
<div class="TabellaOperazioniRicambi" >
    <table width="100%"  border="0" cellspacing="0" cellpadding="0">
        <tbody>
        <tr>
            <th scope="col">Descrizione operazione</th>
            <th scope="col">Note</th>
            <th scope="col">Esito</th>
            <!--<th scope="col">Eseguito</th>-->
        </tr>
        <!-- Inizio repeater repeater repeater --> 
        <OperazioneRiga 
        v-for="(operazione, index) in this.listaOperazioni" :key="index"
        :operazione="operazione"
        :index="index"
        >
        </OperazioneRiga>
        <!-- Fine repeater repeater repeater -->                      
        </tbody>
    </table>
</div>
</template>

<script>

import OperazioneRiga from "@/components/OperazioneRiga.vue"
import OperazioneAttivita from "@/models/operazioneAttivita.model.js";
import {apiMixin} from "/mixin.js";

export default {
    name: "GrigliaOperazioni",
    components:{
        OperazioneRiga
    },
    props: {
        chiaveAttivita: String,
        attivita: Object
    }, 
    data(){
        return {
            listaOperazioni: []
        }
    },
    mixins: [apiMixin],
    created(){  
        let params = {
            GlbAttivita: this.chiaveAttivita
        };
        this.doApiCall("get", "interventi/GetOperazioni", this.$store.getters.getUtente.Token, params).then(
            (data) => {                
                if(data){
                    this.listaOperazioni = data.map(o => {
                        return Object.assign(new OperazioneAttivita(), o)
                    });                                                       
                }           
            }              
        );        
    },
    mounted: function(){
        $('.CustomSelect').select2({
            theme: "classic"
        });
    },
    watch:{
        attivita: function(newValues){
            let params = {
                GlbAttivita: newValues.SysChiaveglobale
            };
            this.doApiCall("get", "interventi/GetOperazioni", this.$store.getters.getUtente.Token, params).then(
                (data) => {                
                    if(data){
                        this.listaOperazioni = data.map(o => {
                            return Object.assign(new OperazioneAttivita(), o)
                        });                                                       
                    }           
                }              
            );
        }
    }
}
</script>